const preScanPT = {
    "form": {
        "modal": {
            "preScanResults": {
                "header": "Resultados do Pre Scan",
                "body": {
                    "description": "Os seguintes resultados foram encontrados após a realização do scan para esta release. Por favor, verifique estes em detalhe:",
                    "table": {
                        "column": {
                            "trackName": "Nome da Faixa",
                            "type": "Tipo",
                            "title": "Título",
                            "artists": "Artistas",
                            "album": "Álbum",
                            "label": "Gravadora",
                            "releaseDate": "Data de Lançamento",
                            "score": "Pontuação (%)"
                        },
                    },
                    "label": {
                        "flaggedTracks": "Faixas Sinalizadas",
                        "music": "Música",
                        "cover": "Capa",
                        "signDeclaration": "Por favor, assine a declaração para continuar.",
                        "cancelRelease": "Quero cancelar esta release.",
                        "approveRelease": {
                            "point1": "Quero aprovar esta release porque os resultados mostrados são 100% idênticos à minha release / transferência do distribuidor anterior.",
                            "point2": "Pela presente, declaro solenemente, sob pena de perjúrio, que todo conteúdo que forneço é de propriedade da minha empresa ou de mim, ou que possuo direitos e licenças completos e válidos necessários para seu uso, distribuição e apresentação.",
                            "point3": "Reconheço e aceito que sou totalmente responsável por qualquer consequência legal que possa surgir da apresentação de tal conteúdo, incluindo mas não limitado a processos legais, reclamações, custos e taxas.",
                            "point4": "Reconheço e aceito que meus dados pessoais, incluindo informações KYC e quaisquer outras informações relevantes, podem ser compartilhados com parceiros autorizados, provedores de serviços digitais (DSPs), terceiros envolvidos no processamento de tal conteúdo, bem como tribunais, autoridades reguladoras e agências de aplicação da lei em caso de qualquer reclamação, disputa ou requisito legal.",
                            "point5": "Reconheço e aceito que Music Link reserva o direito de imediatamente terminar meu acordo, sem qualquer compensação ou obrigação adicional, se for provado que usei este formulário de forma incorreta ou se qualquer parte da minha declaração for falsa, enganosa ou mal representada.",
                        },
                        "noFlaggedTracks": "Nenhuma faixa sinalizada detectada no pre-scan, você pode continuar com os próximos passos!"
                    },
                    "help_text": {
                    },
                },
                "button": {
                    "submit": "Enviar",
                    "close": "Fechar"
                }
            },
            "performScan": {
                "header": "Realizar Pre-Scan",
                "body": "Por favor, confirme que você quer realizar o pre-scan para esta release.",
                "button": {
                    "cancel": "Cancelar",
                    "performScan": "Realizar Scan"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "Você cancelou a distribuição do lançamento, portanto, foi removido.",
            "admin_pending": "Sua declaração está pendente de revisão pela administração para ações futuras.",
            "admin_approved": "Seu pedido para distribuir seu lançamento foi aprovado por nossa equipe administrativa. O lançamento foi verificado com sucesso. Agradecemos sua diligência em garantir precisão e conformidade. O lançamento seguirá para todas as lojas conforme planejado. Obrigado pela sua atenção aos detalhes e adesão aos nossos padrões.",
            "admin_rejected": "Seu pedido para distribuir seu lançamento foi rejeitado. Após uma revisão cuidadosa, o pedido não atende aos nossos requisitos de aprovação. Recomendamos reavaliar o conteúdo e garantir que todas as condições e implicações legais sejam abordadas. Obrigado pela sua compreensão e cooperação.",
            "scanInProgress": "Scan em progresso, por favor, aguarde o scan ser concluído.",
            "releaseMustBeReady": "O lançamento deve estar em status Ready para realizar o pre-scan.",
            "errorSubmittingDeclaration": "Ocorreu um erro ao enviar a declaração do admin para o pre-scan.",
        }
    }
};

export default preScanPT;